import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Creator from './layouts/Creator';
import Main from './layouts/Main';
import { Provider } from 'react-redux';
import { store } from './store';
import Create from './views/Create';
import Index from './views/Index';
import React from 'react';
function App() {
  return (
    <React.Fragment>
      <Provider store={store}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Main />} >
              <Route path="/" element={<Index />} />
            </Route>
            <Route path="/" element={<Creator />} >
              <Route path="/create" element={<Create />} />
            </Route>

          </Routes>
        </BrowserRouter >
      </Provider>
    </React.Fragment>
  );
}

export default App;
